export function registerSW() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js");
    });
  }

  //   // Add this to your Alpine.js init or main app.js
  // if ('serviceWorker' in navigator) {
  //   navigator.serviceWorker.addEventListener('controllerchange', () => {
  //     // This fires when workbox.core.skipWaiting() happens in the SW
  //     console.log("New version detected, reloading...");
  //     window.location.reload();
  //   });
  // }
}

/** Improved Version for Future Perusal 
 * Enables In-Memory hotswap patching
 * 
 * export function registerSW() {
  if ("serviceWorker" in navigator) {
    // Register the SW
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js")
        .then(reg => {
          // Check for updates every time the app comes to foreground
          // (Crucial for iOS PWA 'Next Time' reliability)
          document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") {
              reg.update();
            }
          });
        });
    });

    // Listen for the "Hot Swap"
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      // refreshing check prevents infinite reload loops in some edge cases
      if (refreshing) return;
      refreshing = true;
      console.log("New version detected, reloading...");
      window.location.reload();
    });
  }
}


 */
